import { WCBaseComponent } from './WCBaseComponent.js';

const template = document.createElement('template');

template.innerHTML = `
  <div class="wc-sublist-card card shadow-sm border-0 border-top border-1 border-secondary">
    <div class="wc-sublist-card-header card-header p-2">
    </div>
    <div class="wc-sublist-card-body card-body p-2">
      <ul class="wc-sublist-list-group list-group">
        <li class="wc-sublist-list-group-item list-group-item d-flex">
          <div class="wc-sublist-item-start small">
            <dl class="wc-sublist-dl m-0 mb-1">
              <dt class="wc-sublist-dt m-0 informacao text-gray-600 fw-lighter small"></dt>
              <dd class="wc-sublist-dd m-0"></dd>
            </dl>
          </div>
          <div class="wc-sublist-item-end ms-auto"></div>
        </li>
      </ul>
    </div>
  </div>
`;

export class WCSublistCard extends WCBaseComponent {

  constructor() {
    super();
  }

  render() {
    let contentNodes = [...this.childNodes];
    let clone = template.cloneNode(true);
    let wcSublistCard = clone.content.querySelector('.wc-sublist-card').cloneNode(false);
    contentNodes.forEach(node => {
      wcSublistCard.append(node);
    });
    // this.innerHTML = '';
    this.replaceWith(wcSublistCard);
  }

}

export class WCSublistCardHeader extends WCBaseComponent {

  constructor() {
    super();
  }

  render() {
    let contentNodes = [...this.childNodes];
    let clone = template.cloneNode(true);
    let wcSublistCardHeader = clone.content.querySelector('.wc-sublist-card-header').cloneNode(false);
    contentNodes.forEach(node => {
      wcSublistCardHeader.append(node);
    });
    // this.innerHTML = '';
    this.replaceWith(wcSublistCardHeader);
  }

}

export class WCSublistCardBody extends WCBaseComponent {

  constructor() {
    super();
  }

  render() {
    let contentNodes = [...this.childNodes];
    let clone = template.cloneNode(true);
    let wcSublistCardBody = clone.content.querySelector('.wc-sublist-card-body').cloneNode(false);
    contentNodes.forEach(node => {
      wcSublistCardBody.append(node);
    });
    // this.innerHTML = '';
    this.replaceWith(wcSublistCardBody);
  }

}

export class WCSublistListGroup extends WCBaseComponent {

  constructor() {
    super();
  }

  render() {
    let contentNodes = [...this.childNodes];
    let clone = template.cloneNode(true);
    let wcSublistListGroup = clone.content.querySelector('.wc-sublist-list-group').cloneNode(false);
    contentNodes.forEach(node => {
      wcSublistListGroup.append(node);
    });
    // this.innerHTML = '';
    this.replaceWith(wcSublistListGroup);
  }

}

export class WCSublistListGroupItem extends WCBaseComponent {

  constructor() {
    super();
  }

  render() {
    let contentNodes = [...this.childNodes];
    let clone = template.cloneNode(true);
    let wcSublistListGroupItem = clone.content.querySelector('.wc-sublist-list-group-item').cloneNode(false);
    contentNodes.forEach(node => {
      wcSublistListGroupItem.append(node);
    });
    // this.innerHTML = '';
    this.replaceWith(wcSublistListGroupItem);
  }

}

export class WCSublistItemStart extends WCBaseComponent {

  constructor() {
    super();
  }

  render() {
    let contentNodes = [...this.childNodes];
    let clone = template.cloneNode(true);
    let wcSublistItemStart = clone.content.querySelector('.wc-sublist-item-start').cloneNode(false);
    contentNodes.forEach(node => {
      wcSublistItemStart.append(node);
    });
    // this.innerHTML = '';
    this.replaceWith(wcSublistItemStart);
  }

}

export class WCSublistItemEnd extends WCBaseComponent {

  constructor() {
    super();
  }

  render() {
    let contentNodes = [...this.childNodes];
    let clone = template.cloneNode(true);
    let wcSublistItemEnd = clone.content.querySelector('.wc-sublist-item-end').cloneNode(false);
    contentNodes.forEach(node => {
      wcSublistItemEnd.append(node);
    });
    // this.innerHTML = '';
    this.replaceWith(wcSublistItemEnd);
  }

}

export class WCSublistDl extends WCBaseComponent {

  constructor() {
    super();
  }

  render() {
    let contentNodes = [...this.childNodes];
    let clone = template.cloneNode(true);
    let wcSublistDl = clone.content.querySelector('.wc-sublist-dl').cloneNode(false);
    let wcSublistDt = document.createElement('wc-sublist-dt');
    let wcSublistDd = document.createElement('wc-sublist-dd');
    let dataCaption = this.getAttribute('data-caption');
    wcSublistDt.append(document.createTextNode(dataCaption));
    wcSublistDl.append(wcSublistDt);
    if (contentNodes.length > 0) {
      contentNodes.forEach(node => {
        wcSublistDd.append(node);
      });
    } else {
      let dataIcon = this.getAttribute('data-icon');
      let dataContent = this.getAttribute('data-content');
      // let dataLink = this.getAttribute('data-link') !== null ? this.getAttribute('data-link') : false;
      if (dataIcon !== null) {
        let wcIcon = document.createElement('i');
        wcIcon.setAttribute('class', dataIcon);
        wcSublistDd.append(wcIcon, document.createTextNode(' '));
      }
    //   if (dataLink && dataContent !== '-') {
    //     let elementAnchor = document.createElement('a');
    //     elementAnchor.href = dataContent;
    //     elementAnchor.target = '_blank';
    //     elementAnchor.append(dataContent);
    //     wcSublistDd.append(elementAnchor);
    //   } else {
        wcSublistDd.append(document.createTextNode(dataContent));
    //   }
    }
    wcSublistDl.append(wcSublistDd);
    // this.innerHTML = '';
    this.replaceWith(wcSublistDl);
  }

}

export class WCSublistDt extends WCBaseComponent {

  constructor() {
    super();
  }

  render() {
    let contentNodes = [...this.childNodes];
    let clone = template.cloneNode(true);
    let wcSublistDt = clone.content.querySelector('.wc-sublist-dt').cloneNode(false);
    contentNodes.forEach(node => {
      wcSublistDt.append(node);
    });
    // this.innerHTML = '';
    this.replaceWith(wcSublistDt);
  }

}

export class WCSublistDd extends WCBaseComponent {

  constructor() {
    super();
  }

  render() {
    let contentNodes = [...this.childNodes];
    let clone = template.cloneNode(true);
    let wcSublistDd = clone.content.querySelector('.wc-sublist-dd').cloneNode(false);
    contentNodes.forEach(node => {
      wcSublistDd.append(node);
    });
    // this.innerHTML = '';
    this.replaceWith(wcSublistDd);
  }

}